import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonButton,
  IonCheckbox,
  IonDatetime,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonTextarea,
  IonSearchbar,
  IonContent,
  IonPage,
  IonSpinner,
  IonText,
  IonIcon,
  useIonToast,
} from "@ionic/react";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import Header from "src/components/Header";
import Asignacion from "src/services/asignacion";
import LoginAPI from "src/services/login";
import TimePicker from "src/components/TimePicker";
import ServiciosEspecializadosAPI, {
  AsignacionServicio,
  ProductoOportunidad,
  ServicioRealizado,
  ServicioEspecializado,
} from "src/services/serviciosEspecializados";
import { chevronBackOutline, chevronDownOutline } from "ionicons/icons";
import "./ServiciosEspecializados.css";
import { Dato_Operario } from "src/utils";

type Params = {
  id: string;
};

const formatValue = (value: unknown) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return String(value);
};

const formatDate = (value?: string | null, withTime?: boolean) => {
  if (!value) return "-";
  const parsed = moment(value);
  if (!parsed.isValid()) return formatValue(value);
  return parsed.format(withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY");
};

const formatEstado = (estado?: string | null) => {
  const codigo = (estado || "").toUpperCase().trim();
  switch (codigo) {
    case "FIN":
      return "Finalizado";
    case "PGR":
      return "En progreso";
    case "PEN":
      return "Pendiente";
    default:
      return formatValue(estado);
  }
};

const formatRango = (ent?: string | null, sal?: string | null) => {
  if (!ent || !sal) return "-";
  return `${ent} - ${sal}`;
};

const ServiciosEspecializadosDetalle: React.FC = () => {
  const { id } = useParams<Params>();
  const [dato, setDato] = useState<ServicioEspecializado | null>(null);
  const [productos, setProductos] = useState<ProductoOportunidad[]>([]);
  const [asignaciones, setAsignaciones] = useState<AsignacionServicio[]>([]);
  const [operarios, setOperarios] = useState<Dato_Operario[]>([]);
  const [operarioSel, setOperarioSel] = useState<string>("");
  const [operarioFiltro, setOperarioFiltro] = useState<string>("");
  const [fechaInicio, setFechaInicio] = useState<string>("");
  const [fechaFin, setFechaFin] = useState<string>("");
  const [cargo, setCargo] = useState<string>("");
  const [cedula, setCedula] = useState<string>("");
  const [dias, setDias] = useState<
    Record<
      string,
      { enabled: boolean; ent?: Date; sal?: Date; label: string }
    >
  >({
    lun: { enabled: false, ent: undefined, sal: undefined, label: "Lun" },
    mar: { enabled: false, ent: undefined, sal: undefined, label: "Mar" },
    mie: { enabled: false, ent: undefined, sal: undefined, label: "Mie" },
    jue: { enabled: false, ent: undefined, sal: undefined, label: "Jue" },
    vie: { enabled: false, ent: undefined, sal: undefined, label: "Vie" },
    sab: { enabled: false, ent: undefined, sal: undefined, label: "Sab" },
    dom: { enabled: false, ent: undefined, sal: undefined, label: "Dom" },
  });
  const [guardando, setGuardando] = useState(false);
  const [asignacionesExpanded, setAsignacionesExpanded] = useState(true);
  const [asigPage, setAsigPage] = useState(1);
  const asigPageSize = 10;
  const [loading, setLoading] = useState(true);
  const [productosExpanded, setProductosExpanded] = useState(false);
  const [finalizarOpen, setFinalizarOpen] = useState(false);
  const [numeroOT, setNumeroOT] = useState("");
  const [comentarioFinal, setComentarioFinal] = useState("");
  const [realizados, setRealizados] = useState<ServicioRealizado[]>([]);
  const [realizadosSel, setRealizadosSel] = useState<number[]>([]);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const isDrawingRef = useRef(false);
  const lastPosRef = useRef<{ x: number; y: number } | null>(null);
  const pointerIdRef = useRef<number | null>(null);
  const [present] = useIonToast();
  const history = useHistory();

  useEffect(() => {
    const cargar = async () => {
      const oportunidadId = Number(id);
      if (!oportunidadId || Number.isNaN(oportunidadId)) {
        setLoading(false);
        setDato(null);
        return;
      }
      setLoading(true);
      try {
        const [resp, productosResp, asignacionesResp, operariosResp] =
          await Promise.all([
            ServiciosEspecializadosAPI.obtenerDetalle(oportunidadId),
            ServiciosEspecializadosAPI.listarProductosPorId(oportunidadId),
            ServiciosEspecializadosAPI.listarAsignaciones(oportunidadId),
            Asignacion.listarOperarios(),
          ]);
        setDato(resp?.datos || null);
        setProductos(productosResp?.datos || []);
        setAsignaciones(asignacionesResp?.datos || []);
        setOperarios(operariosResp || []);
        setNumeroOT(String(resp?.datos?.Id || ""));
        try {
          const meResp = await LoginAPI.me();
          setCargo(meResp?.data?.datos?.emp_cargo || "");
          setCedula(String(meResp?.data?.datos?.emp_cedula || ""));
        } catch {
          setCargo("");
          setCedula("");
        }
        try {
          const realizadosResp = await ServiciosEspecializadosAPI.listarServiciosRealizados();
          setRealizados(realizadosResp?.datos || []);
        } catch {
          setRealizados([]);
        }
      } catch (error) {
        setDato(null);
        setProductos([]);
        setAsignaciones([]);
        present({
          message: "No se pudo cargar el detalle del servicio.",
          duration: 2500,
          color: "danger",
        });
        console.error("Detalle servicio especializado:", error);
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, [id, present]);

  useEffect(() => {
    if (!finalizarOpen) return;
    const initCanvas = () => {
      const cv = canvasRef.current;
      if (!cv) return;
      const rect = cv.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      cv.width = Math.max(1, Math.floor(rect.width * dpr));
      cv.height = Math.max(1, Math.floor(rect.height * dpr));
      const ctx = cv.getContext("2d");
      if (ctx) {
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.lineWidth = 2;
        ctx.lineCap = "round";
        ctx.strokeStyle = "#111";
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, rect.width, rect.height);
      }
    };
    requestAnimationFrame(initCanvas);
    const t = setTimeout(initCanvas, 80);
    return () => clearTimeout(t);
  }, [finalizarOpen]);

  const beginDraw = (e: React.PointerEvent<HTMLCanvasElement>) => {
    const cv = canvasRef.current;
    if (!cv) return;
    const rect = cv.getBoundingClientRect();
    e.preventDefault();
    cv.setPointerCapture?.(e.pointerId);
    pointerIdRef.current = e.pointerId;
    isDrawingRef.current = true;
    lastPosRef.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
    const ctx = cv.getContext("2d");
    if (ctx) {
      ctx.beginPath();
      ctx.arc(lastPosRef.current.x, lastPosRef.current.y, 1.2, 0, Math.PI * 2);
      ctx.fillStyle = "#111";
      ctx.fill();
    }
  };

  const draw = (e: React.PointerEvent<HTMLCanvasElement>) => {
    if (!isDrawingRef.current) return;
    const cv = canvasRef.current;
    if (!cv) return;
    const ctx = cv.getContext("2d");
    if (!ctx) return;
    const rect = cv.getBoundingClientRect();
    e.preventDefault();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const last = lastPosRef.current;
    if (!last) return;
    ctx.beginPath();
    ctx.moveTo(last.x, last.y);
    ctx.lineTo(x, y);
    ctx.stroke();
    lastPosRef.current = { x, y };
  };

  const endDraw = () => {
    const cv = canvasRef.current;
    if (cv) {
      try {
        if (pointerIdRef.current !== null) {
          cv.releasePointerCapture?.(pointerIdRef.current);
        }
      } catch {
        // noop
      }
    }
    isDrawingRef.current = false;
    lastPosRef.current = null;
    pointerIdRef.current = null;
  };

  const limpiarFirma = () => {
    const cv = canvasRef.current;
    if (!cv) return;
    const ctx = cv.getContext("2d");
    if (!ctx) return;
    ctx.clearRect(0, 0, cv.width, cv.height);
    const rect = cv.getBoundingClientRect();
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
  };

  const guardarFirma = () => {
    const cv = canvasRef.current;
    if (!cv) return "";
    return cv.toDataURL("image/png");
  };

  const finalizarServicio = async () => {
    if (!dato) return;
    const firma = guardarFirma();
    if (!firma || firma.length < 50) {
      present({
        message: "Realiza la firma antes de finalizar.",
        duration: 2500,
        color: "warning",
      });
      return;
    }
    try {
      await ServiciosEspecializadosAPI.finalizarServicio(dato.Id, {
        firma_b64: firma,
        comentario: comentarioFinal.trim(),
        realizados_ids: realizadosSel,
      });
      setDato({ ...dato, Estado: "FIN", Firma: firma, Comentario: comentarioFinal.trim() });
      setFinalizarOpen(false);
      present({
        message: "Servicio finalizado correctamente.",
        duration: 2500,
        color: "success",
      });
    } catch (error: any) {
      const msg =
        error?.response?.data?.error || "No se pudo finalizar el servicio.";
      present({ message: msg, duration: 2500, color: "danger" });
    }
  };

  const totalPaginas = Math.max(
    1,
    Math.ceil(asignaciones.length / asigPageSize)
  );
  const paginaActual = Math.min(asigPage, totalPaginas);
  const asignacionesPaginadas = asignaciones.slice(
    (paginaActual - 1) * asigPageSize,
    paginaActual * asigPageSize
  );

  const setDiaHabilitado = (dia: string, enabled: boolean) => {
    setDias((prev) => ({
      ...prev,
      [dia]: { ...prev[dia], enabled },
    }));
  };

  const formatHora = (valor?: Date) =>
    valor ? moment(valor).format("HH:mm") : "";

  const buildAsignacionPayload = () => {
    const payload: any = {
      operario: operarioSel,
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin || undefined,
    };
    Object.entries(dias).forEach(([key, info]) => {
      if (!info.enabled) return;
      if (!info.ent || !info.sal) return;
      payload[`${key}_ent`] = formatHora(info.ent);
      payload[`${key}_sal`] = formatHora(info.sal);
    });
    return payload;
  };

  const guardarAsignacion = async () => {
    const oportunidadId = Number(id);
    if (!oportunidadId || Number.isNaN(oportunidadId)) return;
    if (dato?.Estado === "FIN") {
      present({
        message: "El servicio ya esta finalizado.",
        duration: 2500,
        color: "warning",
      });
      return;
    }

    if (!operarioSel || !fechaInicio) {
      present({
        message: "Completa operario y fecha.",
        duration: 2500,
        color: "warning",
      });
      return;
    }
    if (fechaFin && fechaFin < fechaInicio) {
      present({
        message: "La fecha fin no puede ser menor a la fecha inicio.",
        duration: 2500,
        color: "warning",
      });
      return;
    }
    const diasActivos = Object.values(dias).filter((d) => d.enabled);
    if (diasActivos.length === 0) {
      present({
        message: "Selecciona al menos un dia.",
        duration: 2500,
        color: "warning",
      });
      return;
    }
    const diasSinHoras = diasActivos.filter((d) => !d.ent || !d.sal);
    if (diasSinHoras.length > 0) {
      present({
        message: "Completa horas de entrada y salida para los dias elegidos.",
        duration: 2500,
        color: "warning",
      });
      return;
    }

    setGuardando(true);
    try {
      const payload = buildAsignacionPayload();
      await ServiciosEspecializadosAPI.crearAsignacion(oportunidadId, payload);
      const asignacionesResp =
        await ServiciosEspecializadosAPI.listarAsignaciones(oportunidadId);
      setAsignaciones(asignacionesResp?.datos || []);
      setOperarioSel("");
      setFechaInicio("");
      setFechaFin("");
      setDias({
        lun: { enabled: false, ent: undefined, sal: undefined, label: "Lun" },
        mar: { enabled: false, ent: undefined, sal: undefined, label: "Mar" },
        mie: { enabled: false, ent: undefined, sal: undefined, label: "Mie" },
        jue: { enabled: false, ent: undefined, sal: undefined, label: "Jue" },
        vie: { enabled: false, ent: undefined, sal: undefined, label: "Vie" },
        sab: { enabled: false, ent: undefined, sal: undefined, label: "Sab" },
        dom: { enabled: false, ent: undefined, sal: undefined, label: "Dom" },
      });
      present({
        message: "Asignacion guardada correctamente.",
        duration: 2500,
        color: "success",
      });
    } catch (error: any) {
      const msg =
        error?.response?.data?.error ||
        "No se pudo guardar la asignacion.";
      present({
        message: msg,
        duration: 2500,
        color: "danger",
      });
    } finally {
      setGuardando(false);
    }
  };

  const operariosFiltrados = operarios.filter((op) => {
    const filtro = operarioFiltro.trim().toLowerCase();
    if (!filtro) return false;
    return (
      op.nombre.toLowerCase().includes(filtro) ||
      String(op.legajo).toLowerCase().includes(filtro)
    );
  });

  return (
    <IonPage>
      <Header
        titulo="Detalle Servicio"
        botonIzq={{
          icono: chevronBackOutline,
          action: () => history.push("/servicios-especializados"),
        }}
      />
      <IonContent>
        {loading ? (
          <div className="se-center">
            <IonSpinner />
          </div>
        ) : !dato ? (
          <div className="se-center">
            <IonText>No se encontro el servicio solicitado.</IonText>
          </div>
        ) : (
          <div className="se-list">
            <IonCard>
              <IonCardHeader>
                <IonCardTitle>{dato.NroPresupuesto}</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <div className="se-grid">
                  <div>
                    <span className="se-label">Contacto:</span>
                    <strong>{formatValue(dato.Contacto)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Tipo presupuesto:</span>
                    <strong>{formatValue(dato.TipoPresupuesto)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Mes cobertura:</span>
                    <strong>{formatDate(dato.MesCobertura)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Unidad negocio:</span>
                    <strong>{formatValue(dato.UnidadNegocio)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Punto servicio:</span>
                    <strong>{formatValue(dato.PuntoServicio)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Nombre fantasia:</span>
                    <strong>{formatValue(dato.NombreFantasia)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Rubro:</span>
                    <strong>{formatValue(dato.Rubro)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Ejecutivo venta:</span>
                    <strong>{formatValue(dato.EjecutivoVenta)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Observacion:</span>
                    <strong>{formatValue(dato.Observacion)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Fecha inicio:</span>
                    <strong>{formatDate(dato.FechaInicio)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Total m2:</span>
                    <strong>{formatValue(dato.TotalMetros2)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Cant. horas:</span>
                    <strong>{formatValue(dato.CantHoras)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Cuenta:</span>
                    <strong>{formatValue(dato.Cuenta)}</strong>
                  </div>
                  <div>
                    <span className="se-label">Estado:</span>
                    <strong>{formatEstado(dato.Estado)}</strong>
                  </div>
                </div>
                <div className="se-products">
                  <div className="se-products-header">
                    <div className="se-products-title">Productos</div>
                    <IonButton
                      size="small"
                      fill="clear"
                      onClick={() => setProductosExpanded(!productosExpanded)}
                      aria-label="Mostrar productos"
                    >
                      <IonIcon icon={chevronDownOutline} />
                    </IonButton>
                  </div>
                  {productosExpanded && (
                    productos.length === 0 ? (
                      <IonText color="medium">Sin productos asociados.</IonText>
                    ) : (
                      <div className="se-products-list">
                        {productos.map((prod, idx) => (
                          <div key={`${dato.Id}-${idx}`} className="se-product">
                            <div className="se-product-name">
                              {formatValue(prod.NombreProducto)}
                            </div>
                            <div className="se-product-desc">
                              {formatValue(prod.Descripcion)}
                            </div>
                            <div className="se-product-qty">
                              Cantidad: {formatValue(prod.Cantidad)}
                            </div>
                          </div>
                        ))}
                      </div>
                    )
                  )}
                </div>
                <div className="se-assignments">
                  <div className="se-products-header">
                    <div className="se-products-title">Asignaciones</div>
                    <IonButton
                      size="small"
                      fill="clear"
                      onClick={() =>
                        setAsignacionesExpanded(!asignacionesExpanded)
                      }
                      aria-label="Mostrar asignaciones"
                    >
                      <IonIcon icon={chevronDownOutline} />
                    </IonButton>
                  </div>

                  {asignacionesExpanded && (
                    <>
                      {asignaciones.length === 0 ? (
                        <IonText color="medium">
                          No hay asignaciones para este servicio.
                        </IonText>
                      ) : (
                        <div className="se-assignments-table">
                          <div className="se-assignments-row se-assignments-header">
                            <div>Operario</div>
                            <div>Lun</div>
                            <div>Mar</div>
                            <div>Mie</div>
                            <div>Jue</div>
                            <div>Vie</div>
                            <div>Sab</div>
                            <div>Dom</div>
                          </div>
                          {asignacionesPaginadas.map((asig) => (
                            <div key={asig.id} className="se-assignments-row">
                              <div className="se-assignments-op">
                                {asig.operario} - {asig.legajo}
                              </div>
                              <div>{formatRango(asig.lun_ent, asig.lun_sal)}</div>
                              <div>{formatRango(asig.mar_ent, asig.mar_sal)}</div>
                              <div>{formatRango(asig.mie_ent, asig.mie_sal)}</div>
                              <div>{formatRango(asig.jue_ent, asig.jue_sal)}</div>
                              <div>{formatRango(asig.vie_ent, asig.vie_sal)}</div>
                              <div>{formatRango(asig.sab_ent, asig.sab_sal)}</div>
                              <div>{formatRango(asig.dom_ent, asig.dom_sal)}</div>
                            </div>
                          ))}
                          <div className="se-assignments-pagination">
                            <IonButton
                              size="small"
                              fill="outline"
                              disabled={paginaActual <= 1}
                              onClick={() => setAsigPage(paginaActual - 1)}
                            >
                              Anterior
                            </IonButton>
                            <IonText>
                              Pagina {paginaActual} de {totalPaginas}
                            </IonText>
                            <IonButton
                              size="small"
                              fill="outline"
                              disabled={paginaActual >= totalPaginas}
                              onClick={() => setAsigPage(paginaActual + 1)}
                            >
                              Siguiente
                            </IonButton>
                          </div>
                        </div>
                      )}

                      <div className="se-assignment-form">
                        {dato.Estado === "FIN" && (
                          <IonText color="medium">
                            Este servicio ya esta finalizado y no admite nuevas asignaciones.
                          </IonText>
                        )}
                        <IonItem>
                          <IonLabel position="stacked">Operario</IonLabel>
                          <IonSearchbar
                            placeholder="Buscar por nombre o legajo"
                            value={operarioFiltro}
                            debounce={300}
                            onIonChange={(ev) =>
                              setOperarioFiltro(ev.detail.value || "")
                            }
                            disabled={dato.Estado === "FIN"}
                          />
                          {operarioFiltro.trim().length > 0 && (
                            <IonList className="se-operarios-list">
                              {operariosFiltrados.slice(0, 8).map((op) => (
                                <IonItem
                                  key={op.legajo}
                                  button
                                  onClick={() => {
                                    setOperarioSel(`${op.nombre} - ${op.legajo}`);
                                    setOperarioFiltro("");
                                  }}
                                  disabled={dato.Estado === "FIN"}
                                >
                                  <IonLabel>
                                    {op.nombre} - {op.legajo}
                                  </IonLabel>
                                </IonItem>
                              ))}
                            </IonList>
                          )}
                          {operarioSel && (
                            <IonText color="medium">
                              Seleccionado: {operarioSel}
                            </IonText>
                          )}
                        </IonItem>
                        <IonItem>
                          <IonLabel position="stacked">Fecha inicio</IonLabel>
                          <IonDatetime
                            displayFormat="DD/MM/YYYY"
                            value={fechaInicio}
                            onIonChange={(ev) =>
                              setFechaInicio(
                                (ev.detail.value || "").toString().slice(0, 10)
                              )
                            }
                            disabled={dato.Estado === "FIN"}
                          />
                        </IonItem>
                        <IonItem>
                          <IonLabel position="stacked">Fecha fin</IonLabel>
                          <IonDatetime
                            displayFormat="DD/MM/YYYY"
                            value={fechaFin}
                            onIonChange={(ev) =>
                              setFechaFin(
                                (ev.detail.value || "").toString().slice(0, 10)
                              )
                            }
                            disabled={dato.Estado === "FIN"}
                          />
                        </IonItem>
                        <div className="se-days">
                          {Object.entries(dias).map(([key, info]) => (
                            <div key={key} className="se-day-row">
                              <IonItem lines="none" className="se-day-check">
                                <IonCheckbox
                                  checked={info.enabled}
                                  onIonChange={(ev) =>
                                    setDiaHabilitado(key, ev.detail.checked)
                                  }
                                  disabled={dato.Estado === "FIN"}
                                />
                                <IonLabel className="se-day-label">
                                  {info.label}
                                </IonLabel>
                              </IonItem>
                              <IonItem lines="none" className="se-day-time">
                                <TimePicker
                                  placeholder="Entrada"
                                  value={info.ent}
                                  disabled={!info.enabled || dato.Estado === "FIN"}
                                  setValue={(date) =>
                                    setDias((prev) => ({
                                      ...prev,
                                      [key]: {
                                        ...prev[key],
                                        ent: date,
                                      },
                                    }))
                                  }
                                />
                              </IonItem>
                              <IonItem lines="none" className="se-day-time">
                                <TimePicker
                                  placeholder="Salida"
                                  value={info.sal}
                                  disabled={!info.enabled || dato.Estado === "FIN"}
                                  setValue={(date) =>
                                    setDias((prev) => ({
                                      ...prev,
                                      [key]: {
                                        ...prev[key],
                                        sal: date,
                                      },
                                    }))
                                  }
                                />
                              </IonItem>
                            </div>
                          ))}
                        </div>
                        <IonButton
                          expand="block"
                          onClick={guardarAsignacion}
                          disabled={guardando || dato.Estado === "FIN"}
                        >
                          Guardar asignacion
                        </IonButton>
                      </div>
                      {dato.Estado !== "FIN" &&
                        (cargo.toLowerCase().includes("desarrollador") ||
                          cedula === "4218167") && (
                        <IonButton
                          expand="block"
                          color="success"
                          onClick={() => setFinalizarOpen(true)}
                          className="se-finalizar-btn"
                        >
                          Finalizar servicio
                        </IonButton>
                      )}
                    </>
                  )}
                </div>
              </IonCardContent>
            </IonCard>
          </div>
        )}
      </IonContent>

      <IonModal isOpen={finalizarOpen} onDidDismiss={() => setFinalizarOpen(false)}>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle style={{ textAlign: "center" }}>Finalizar Servicio</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className="se-finalizar-modal">
            <IonItem>
              <IonLabel position="stacked">Numero de OT (autogenerado)</IonLabel>
              <IonInput value={numeroOT} readonly disabled />
            </IonItem>
            {realizados.length > 0 && (
              <div className="se-realizados-list">
                <IonLabel className="se-realizados-title">
                  Servicios realizados
                </IonLabel>
                {realizados.map((srv) => (
                  <IonItem key={srv.id} lines="none">
                    <IonCheckbox
                      checked={realizadosSel.includes(srv.id)}
                      onIonChange={(ev) => {
                        setRealizadosSel((prev) =>
                          ev.detail.checked
                            ? [...prev, srv.id]
                            : prev.filter((id) => id !== srv.id)
                        );
                      }}
                    />
                    <IonLabel className="se-day-label">{srv.servicio}</IonLabel>
                  </IonItem>
                ))}
              </div>
            )}
            <IonItem>
              <IonLabel position="stacked">Comentario</IonLabel>
              <IonTextarea
                value={comentarioFinal}
                onIonChange={(ev) =>
                  setComentarioFinal((ev.detail.value || "") as string)
                }
                autoGrow
                placeholder="Escribe un comentario"
              />
            </IonItem>
            <div className="se-signature-hint">Firma en el recuadro</div>
            <div className="se-signature-box">
              <canvas
                ref={canvasRef}
                style={{ width: "100%", height: "100%", touchAction: "none" }}
                onPointerDown={beginDraw}
                onPointerMove={draw}
                onPointerUp={endDraw}
                onPointerLeave={endDraw}
                onPointerCancel={endDraw}
              />
            </div>
            <div className="se-signature-actions">
              <IonButton color="medium" onClick={() => setFinalizarOpen(false)}>
                Cancelar
              </IonButton>
              <IonButton color="medium" onClick={limpiarFirma}>
                Limpiar
              </IonButton>
              <IonButton color="primary" onClick={finalizarServicio}>
                Confirmar
              </IonButton>
            </div>
          </div>
        </IonContent>
      </IonModal>
    </IonPage>
  );
};

export default ServiciosEspecializadosDetalle;
